import * as React from 'react';
import { PromoCodeViewProps } from '../../components/promo-code';
import { ICalendarAppState } from '../../redux-state';
import Promocode = require('../../classes/promo-code');
import IPromoCodeState = Promocode.IPromoCodeState;
import PromoCodeState = Promocode.PromoCodeState;
import { connect } from 'react-redux';
import { CalendarDeviceMode } from '../../classes/calendar';

interface StateToProps {
    promoCodeState: IPromoCodeState;
    promoCodeError: any;
    promoCodeResponse: any;
}

type JoinedPromoCodeProps = StateToProps & PromoCodeViewProps;

const PromoCodeView: React.StatelessComponent<JoinedPromoCodeProps> = props => {
    function onTextChange(evt: React.ChangeEvent<HTMLInputElement>) {
        props.updatePromoCodeString(evt.currentTarget.value);
    }

    function getPromoDescription(): string {
        const pagePromoCodeData = JSON.parse((window as any).promoCode).promoCode;
        const promoCodeStateDate = props.promoCodeState.promoApiResponse;
        if (promoCodeStateDate != null) {
            return promoCodeStateDate.source.description;
        }
        return pagePromoCodeData != null ? pagePromoCodeData.source.description : "";
    }

    function getClassName(): string {
        if (props.show) {
            return "ace-cal-promo-form-control show-promo";
        }
        return "ace-cal-promo-form-control hide-promo";
    }

    function showPromoMessage() {
        return props.showPromoResult
            ? props.promoCodeState.promoCodeState === PromoCodeState.FAILURE
                ? props.promoCodeError
                : props.promoCodeResponse
            : '';
    }
    function getPromoForm() {

        if (props.promoCodeState.promoCodeState === PromoCodeState.APPLIED) {
            return <form className="ace-cal-promo-form" onSubmit={props.removePromoCode}>
                <div className="ace-cal-promo-form-inner">
                    <label htmlFor="PromoCodeInput" className="ace-cal-promo-form-label">{props.text.promoCodeDescriptionText}</label>
                    <div className="ace-cal-promo-form-inputs">
                        <div className="ace-cal-promo-value">{props.promoCodeState.appliedPromoCode}</div>
                        <button className="ace-cal-promo-submit un-button primary-link">Remove</button>
                    </div>
                </div>
            </form>
        }
        else {
            return <form className="ace-cal-promo-form" onSubmit={props.submitPromoCode}>
                <div className="ace-cal-promo-form-inner stack-xs">
                    <label htmlFor="PromoCodeInput" className="ace-cal-promo-form-label">{props.text.promoCodeDescriptionText}</label>
                    <div className="ace-cal-promo-form-inputs">
                        <input type="text" onChange={onTextChange} id="PromoCodeInput" placeholder={props.text.promoCodeDescriptionText} />
                        <button className="ace-cal-promo-submit btn-outline">{props.text.applyPromoCodeButtonText}</button>
                    </div>
                    {
                        showPromoMessage() !== '' &&
                        <div className="ace-cal-promo-text caption" dangerouslySetInnerHTML={{ __html: showPromoMessage() }}>{ }</div>
                    }
                </div>
            </form>
        }
    }

    return (
        (props.deviceMode === CalendarDeviceMode.MOBILE || props.filtersAlwaysModal) ?
            <div id="promo-code-dialog" className="ace-cal-modal-container">
                <div tabIndex={-1} data-a11y-dialog-hide className="ace-cal-modal-bg"></div>
                <div role="dialog" className="">
                    <div className="ace-cal-modal">
                        <div className="ace-cal-modal-inner">
                            <div className={getClassName()}>
                                {getPromoForm()}
                            </div>
                            <button type="button" data-a11y-dialog-hide aria-label={props.text.filterCloseButtonLabel} className="ace-cal-modal-close"></button>
                        </div>
                    </div>
                </div>
            </div>
            :
            <div className={getClassName()}>
                {getPromoForm()}
            </div>
    );
}

function mapStateToProps(state: ICalendarAppState, ownProps: PromoCodeViewProps): StateToProps {
    return {
        promoCodeState: state.promoCode,
        promoCodeError: '<p class="error-message">' + state.promoCode.promoCodeError + '</p>',
        promoCodeResponse: state.promoCode.promoApiResponse
    }
}

export default connect<StateToProps>(mapStateToProps)(PromoCodeView);